import { useState, useEffect } from "react";

export type Breakpoint = "mobile" | "tablet" | "laptop" | "desktop";

const queries = [
  { label: "mobile" as Breakpoint, query: "(max-width: 767px)" },
  { label: "tablet" as Breakpoint, query: "(min-width: 768px) and (max-width: 1023px)" },
  { label: "laptop" as Breakpoint, query: "(min-width: 1024px) and (max-width: 1279px)" },
  { label: "desktop" as Breakpoint, query: "(min-width: 1280px)" },
];

export function useBreakpoint(): Breakpoint {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() => {
    if (typeof window === "undefined") return "desktop";
    if (window.innerWidth < 768) return "mobile";
    if (window.innerWidth < 1024) return "tablet";
    if (window.innerWidth < 1280) return "laptop";
    return "desktop";
  });

  useEffect(() => {
    const mqlList = queries.map(({ label, query }) => {
      const mql = window.matchMedia(query);
      const handler = (e: MediaQueryListEvent) => {
        if (e.matches) setBreakpoint(label);
      };
      mql.addEventListener("change", handler);
      return { mql, handler };
    });

    return () => {
      mqlList.forEach(({ mql, handler }) =>
        mql.removeEventListener("change", handler),
      );
    };
  }, []);

  return breakpoint;
}

export function useIsMobile(): boolean {
  const bp = useBreakpoint();
  return bp === "mobile";
}

export function useIsTablet(): boolean {
  const bp = useBreakpoint();
  return bp === "tablet";
}

export function useIsDesktop(): boolean {
  const bp = useBreakpoint();
  return bp === "laptop" || bp === "desktop";
}
